import React from 'react'
import { withRouter } from 'react-router-dom'
import { Config } from '../config'
import { Menu, Button, Badge, MenuProps } from 'antd'
import { NavLink } from 'react-router-dom'
import { AuthService, DashboardService, InformfixService } from '../services'
import {
  HomeOutlined,
  LoginOutlined,
  MinusOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import NotificationCount from '../components/NotificationCount'
import { inject, observer } from 'mobx-react'
import AuthStore from '../stores/AuthStore'

function getItem(label, key, icon, children, theme) {
  return {
    key,
    icon,
    children,
    label,
    theme,
  };
}

@inject(['informStore'])
@inject('authStore')
@observer
class MenuSidebar extends React.Component {
  state = {
    // menuItems: Config.sidebarItems,
    menuItems: [],
    collapsed: false,
    backgroundColor: 'rgba(52, 3, 89,1)',
    fontColor: '#ffffff',
    intervalCount: null,
    loadingSidebar: false,
    current: '',
  }

  componentDidMount() {
    this.getMenu()
    this.getCountAllStatus()
    var vm = this
    this.checkNew()
  }

  getMenu() {
    this.setState({
      loadingSidebar: true,
    })
    if (AuthService.isLoggedIn()) {
      DashboardService.menu()
        .then((rs) => {
          let items = [
            ...rs.data,
            {
              label: 'ออกจากระบบ',
              key: 'logout',
              icon: <LoginOutlined />,
            },
          ]
          this.setState({
            menuItems: items,
            loadingSidebar: false,
          })
        })
        .catch((err) => {
          this.setState({
            loadingSidebar: false,
            menuItems: [
              {
                label: 'เข้าสู่ระบบ',
                key: 'login',
                icon: <LoginOutlined />,
                to: '/login',
              },
            ],
          })
        })
    } else {
      this.setState({
        loadingSidebar: false,
        menuItems: [
          {
            label: 'เข้าสู่ระบบ',
            key: 'login',
            icon: <LoginOutlined />,
            to: '/login',
          },
        ],
      })
    }
  }

  /**
   * นับสถานะใบแจ้งซ่อม
   */
  getCountAllStatus() {
    console.log('check count inform')
    InformfixService.countNewInform().then((rs) => {
      if (rs) {
        const data = rs.data
        this.props.informStore.countNewInform = data.total
      }
    })
    InformfixService.count4task().then((rs) => {
      if (rs) {
        const data = rs.data
        this.props.informStore.count4task = data.total
      }
    })
    InformfixService.countPostpone().then((rs) => {
      if (rs) {
        const data = rs.data
        this.props.informStore.countPostpone = data.total
      }
    })
  }
  checkNew = () => {
    this.intervalCount = setInterval(() => {
      this.getCountAllStatus()
    }, 3000)
    clearInterval(this.intervalCount)
  }
  toggleCollapsed = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }
  isLoggedIn() {
    return AuthService.isLoggedIn()
  }

  doLogout = () => {
    AuthService.logout()
    this.props.history.push('/login')
  }
  render() {
    const { loadingSidebar, menuItems } = this.state

    const menuItemsExample = [
      {
        label: 'Navigation One',
        key: 'mail',
        icon: <HomeOutlined />,
      },
      {
        label: 'Navigation Two',
        key: 'app',
        icon: <HomeOutlined />,
        disabled: true,
      },
      {
        label: 'Navigation Three - Submenu',
        key: 'SubMenu',
        icon: <HomeOutlined />,
        children: [
          {
            type: 'group',
            label: 'Item 1',
            children: [
              {
                label: 'Option 1',
                key: 'setting:1',
              },
              {
                label: 'Option 2',
                key: 'setting:2',
              },
            ],
          },
          {
            type: 'group',
            label: 'Item 2',
            children: [
              {
                label: 'Option 3',
                key: 'setting:3',
              },
              {
                label: 'Option 4',
                key: 'setting:4',
              },
            ],
          },
        ],
      },
      {
        label: (
          <a
            href="https://ant.design"
            target="_blank"
            rel="noopener noreferrer"
          >
            Navigation Four - Link
          </a>
        ),
        key: 'alipay',
      },
    ]

    const handleClick = (e) => {
      const item = e.item.props
      // console.log('click', e)
      // console.log('item', item)
      const key = e.key
      if (key == 'logout') {
        this.doLogout()
        window.location.reload()
      }
      if (item.to !== undefined) {
        this.props.history.push(item.to)
      }

      this.setState({
        current: key,
      })

      if (this.props.onClickHandle) {
        this.props.onClickHandle(key)
      }
    }

    return (
      <React.Fragment>
        <Menu mode="inline" onClick={handleClick} items={menuItems} />
      </React.Fragment>
    )
  }
}

export default withRouter(MenuSidebar)
